export class UserLoginInfo
{
    constructor(username: string, password: string, tenantId: string = null, organizationId: number = 0)
    {
        this.username = username;
        this.password = password;
        this.tenantId = tenantId;
        this.organizationId = organizationId;
    }

    grantType = 'password';
    username: string;
    password: string;
    tenantId: string;
    organizationId: number;
    allowMultipleOrgResponse = true;
}
